function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-68"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.22,
    y: 398.49,
    width: 21.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.56,
    y: 393.31,
    width: 34.11,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 44.53,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.88,
    y: 394.25,
    width: 11.14,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.58,
    y: 394.25,
    width: 38.39,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.31,
    y: 390.03,
    width: 27.7,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,174.63a20.91,20.91,0,0,0,0-41.82h-2.57v41.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.41,
    cy: 153.72,
    r: 20.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,156.34a28,28,0,0,1-28-28V111.63a2.63,2.63,0,0,1,5.26,0v16.72a22.76,22.76,0,0,0,22.73,22.74,2.63,2.63,0,1,1,0,5.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.83,126.35h46.52a4.86,4.86,0,0,0,4.7-6.1L110,105a4.86,4.86,0,0,0-4.69-3.62H66.87a4.87,4.87,0,0,0-4.7,3.62l-4,15.23A4.85,4.85,0,0,0,62.83,126.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.28,174.63a20.91,20.91,0,1,0,0-41.82h-2.57v41.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.71,
    cy: 153.72,
    r: 20.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.75,156.34a28,28,0,0,1-28-28V111.63a2.63,2.63,0,0,1,5.26,0v16.72a22.76,22.76,0,0,0,22.73,22.74,2.63,2.63,0,1,1,0,5.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.13,126.35h46.52a4.86,4.86,0,0,0,4.7-6.1l-4-15.23a4.86,4.86,0,0,0-4.69-3.62H362.17a4.87,4.87,0,0,0-4.7,3.62l-4,15.23A4.85,4.85,0,0,0,358.13,126.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.98,
    y: 256.92,
    width: 15.21,
    height: 58.93,
    transform: "translate(283.17 572.78) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.75 315.85 143.22 315.85 150.84 246.88 100.37 246.88 92.75 315.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.28 315.85 139.42 315.85 147.04 246.88 94.91 246.88 87.28 315.85",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.65 310.42 142.07 252.32 98.67 252.32 92.25 310.42 135.65 310.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.69,296.33,127,294c1.61-14.58-7.49-27.57-19.31-27.57h0l-.27,2.37c-1.61,14.57,7.49,27.56,19.32,27.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.08,
    y: 315.85,
    width: 44.84,
    height: 66.55,
    transform: "translate(163.01 698.25) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.59 382.4 59.08 382.4 59.08 369.57 68.32 369.57 63.59 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.75,
    y: 315.85,
    width: 44.84,
    height: 66.55,
    transform: "translate(414.35 698.25) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.08,
    y: 315.85,
    width: 129.61,
    height: 58.67,
    transform: "translate(247.77 690.38) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.18 382.4 188.69 382.4 188.69 369.57 179.45 369.57 184.18 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.58,
    y: 319.52,
    width: 122.61,
    height: 23.68,
    transform: "translate(247.77 662.72) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.71,335h16.35a25.84,25.84,0,0,0,18.78-8.08H96.93A25.87,25.87,0,0,0,115.71,335Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.58,
    y: 347.02,
    width: 122.61,
    height: 23.68,
    transform: "translate(247.77 717.72) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.71,362.46h16.35a25.84,25.84,0,0,0,18.78-8.08H96.93A25.87,25.87,0,0,0,115.71,362.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.48,313.14h1.16c0-2.39,0-8.44.12-22.31.21-25.15.61-26.68.61-26.68l-2.76,11.61C177.86,288.61,180.12,301.53,180.48,313.14Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.19,274c-4-4.73-12.45-6.11-21.13-7.29-3.41-.46,8.95,7.33,15,12.86,4.7,4.3,7.7,5.49,9,9.77C181.72,284,181.61,278.11,178.19,274Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.46,282.48c4-4.73,12.45-6.1,21.13-7.28,3.41-.46-9,7.33-15,12.86-4.7,4.3-7.7,5.49-9,9.77C179.93,292.49,180,286.56,183.46,282.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76,263c3-5.66,10.46-11,18.87-13,3.3-.79-7.65,10.44-11.81,17.69-3.23,5.62-7.51,12.24-8.18,17C179.64,275.31,178.78,268.69,181.76,263Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,315.85h0c-3.54,0-6.47-1.77-6.68-4.05l-.59-3.88h14.55l-.6,3.88C187.88,314.08,185,315.85,181.4,315.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.62 309.41 173.19 309.41 172.72 305.08 190.09 305.08 189.62 309.41",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.54,
    y: 80.59,
    width: 160.21,
    height: 146.13,
    transform: "translate(499.29 307.31) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.93,
    y: 80.59,
    width: 162.24,
    height: 146.13,
    transform: "translate(494.11 307.31) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.54,
    y: 79.01,
    width: 133.04,
    height: 149.3,
    transform: "translate(400.71 -93.4) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.39 220.18 244.63 87.14 224.67 87.14 283.43 220.18 303.39 220.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.77 220.18 219.01 87.14 205.27 87.14 264.03 220.18 277.77 220.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.46,
    y: 149.8,
    width: 133.04,
    height: 7.72,
    transform: "translate(377.64 -70.33) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.78,
    y: 149.8,
    width: 133.04,
    height: 7.72,
    transform: "translate(428.96 -121.65) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.54,
    y: 148.42,
    width: 142.06,
    height: 9.76,
    transform: "translate(374.87 -68.27) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.86,
    y: 148.42,
    width: 142.06,
    height: 9.76,
    transform: "translate(426.19 -119.59) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.23,
    y: 153.31,
    width: 133.04,
    height: 0.69,
    transform: "translate(326.41 -19.09) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.22,72.17H336.78a.85.85,0,0,1,.84.84h0a.84.84,0,0,1-.84.83H163.22a.84.84,0,0,1-.84-.83h0A.85.85,0,0,1,163.22,72.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.75,77.68h0a1.13,1.13,0,0,0,1.12-1.13V74.13A1.12,1.12,0,0,0,329.75,73h0a1.13,1.13,0,0,0-1.13,1.12v2.42A1.14,1.14,0,0,0,329.75,77.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,77.68h0a1.14,1.14,0,0,0,1.13-1.13V74.13A1.13,1.13,0,0,0,175.8,73h0a1.12,1.12,0,0,0-1.12,1.12v2.42A1.13,1.13,0,0,0,175.8,77.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.48,
    y: 73.01,
    width: 162.13,
    height: 114.44,
    transform: "translate(489.09 260.45) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.95,
    y: 259.97,
    width: 38.72,
    height: 23.7,
    rx: 5.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.95,
    y: 255.59,
    width: 38.72,
    height: 5.08,
    rx: 1.81,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52,310s.51,16.67,19.93,16.67S347.38,310,347.38,310Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.8,310s.51,16.67,19.93,16.67S391.66,310,391.66,310Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.24,
    y: 249.24,
    width: 53.2,
    height: 34.44,
    rx: 7.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.24,
    y: 243.22,
    width: 53.2,
    height: 6.98,
    rx: 2.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.9,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(590.83 682.15) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.13,
    y: 283.67,
    width: 27.29,
    height: 16.08,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.45,
    y: 283.67,
    width: 135.68,
    height: 16.08,
    transform: "translate(686.57 583.43) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.13,
    y: 326.62,
    width: 27.29,
    height: 16.08,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.45,
    y: 326.62,
    width: 135.68,
    height: 16.08,
    transform: "translate(686.57 669.32) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.58,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(862.19 682.15) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.09,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(817.22 682.15) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.45,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(555.93 682.15) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-68"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-68",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Login--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.41,365.5H132.84a8.13,8.13,0,0,1-8-7.64L113.4,136.31a7.17,7.17,0,0,1,7.24-7.63H248.21a8.12,8.12,0,0,1,8,7.63l11.42,221.55A7.18,7.18,0,0,1,260.41,365.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.41,365.5H132.84a8.13,8.13,0,0,1-8-7.64L113.4,136.31a7.17,7.17,0,0,1,7.24-7.63H248.21a8.12,8.12,0,0,1,8,7.63l11.42,221.55A7.18,7.18,0,0,1,260.41,365.5Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.51,
    y: 121.46,
    width: 14.11,
    height: 1,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.45,
    y: 121.46,
    width: 5.17,
    height: 1,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9,351.44h-122a7.77,7.77,0,0,1-7.68-7.29l-10.92-211.9a6.86,6.86,0,0,1,6.93-7.3h122a7.77,7.77,0,0,1,7.67,7.3l10.92,211.9A6.85,6.85,0,0,1,265.9,351.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9,346.57h-122a2.92,2.92,0,0,1-2.81-2.68L130.16,132a2,2,0,0,1,.54-1.55,2,2,0,0,1,1.52-.62h122a2.92,2.92,0,0,1,2.8,2.68L268,344.4a2,2,0,0,1-2.05,2.17ZM132.22,130.08a1.79,1.79,0,0,0-1.34.54,1.84,1.84,0,0,0-.47,1.37l10.92,211.89a2.67,2.67,0,0,0,2.56,2.44h122a1.74,1.74,0,0,0,1.33-.54,1.76,1.76,0,0,0,.47-1.37L256.78,132.52a2.66,2.66,0,0,0-2.55-2.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.09,
    cy: 180.61,
    rx: 36,
    ry: 37.9,
    transform: "translate(-70.12 194.99) rotate(-45.74)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,180.61a28.71,28.71,0,0,1-2.87,14.24,28.07,28.07,0,0,1-25.47,15.65,31.75,31.75,0,0,1-27.08-15.65,30.78,30.78,0,0,1-4.34-14.24,28.09,28.09,0,0,1,28.34-29.88A31.81,31.81,0,0,1,226,180.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.1,194.85a28.07,28.07,0,0,1-25.47,15.65,31.75,31.75,0,0,1-27.08-15.65,45.16,45.16,0,0,1,25.86-8A49.14,49.14,0,0,1,223.1,194.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.56,
    cy: 170.39,
    rx: 12.97,
    ry: 13.66,
    transform: "translate(-62.95 191.52) rotate(-45.74)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.41,269H152.88a3.29,3.29,0,0,1-3.25-3.09l-.72-14a2.9,2.9,0,0,1,2.93-3.08h95.53a3.29,3.29,0,0,1,3.25,3.08l.72,14A2.9,2.9,0,0,1,248.41,269Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.16,241.1h-39.9A3.29,3.29,0,0,1,176,238l-.15-3a2.9,2.9,0,0,1,2.93-3.09h39.89a3.29,3.29,0,0,1,3.25,3.09l.16,3A2.92,2.92,0,0,1,219.16,241.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,336.31H174.23a5.61,5.61,0,0,1-5.53-5.26l-.35-6.9a5,5,0,0,1,5-5.26H233.1a5.61,5.61,0,0,1,5.53,5.26l.35,6.9A5,5,0,0,1,234,336.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,302.86H154.62a3.3,3.3,0,0,1-3.25-3.09l-.72-14a2.91,2.91,0,0,1,2.93-3.09h95.53a3.29,3.29,0,0,1,3.25,3.09l.73,14A2.92,2.92,0,0,1,250.16,302.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,258.91a3.22,3.22,0,0,1-3.25,3.42,3.64,3.64,0,0,1-3.59-3.42,3.21,3.21,0,0,1,3.24-3.42A3.65,3.65,0,0,1,165,258.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53,258.91a3.21,3.21,0,0,1-3.24,3.42,3.63,3.63,0,0,1-3.59-3.42,3.21,3.21,0,0,1,3.24-3.42A3.63,3.63,0,0,1,175.53,258.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,258.91a3.21,3.21,0,0,1-3.24,3.42,3.65,3.65,0,0,1-3.6-3.42,3.22,3.22,0,0,1,3.25-3.42A3.64,3.64,0,0,1,186,258.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.55,258.91a3.22,3.22,0,0,1-3.24,3.42,3.65,3.65,0,0,1-3.6-3.42,3.22,3.22,0,0,1,3.24-3.42A3.65,3.65,0,0,1,196.55,258.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.77,292.75a3.21,3.21,0,0,1-3.24,3.42,3.65,3.65,0,0,1-3.6-3.42,3.22,3.22,0,0,1,3.25-3.42A3.64,3.64,0,0,1,166.77,292.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.28,292.75a3.22,3.22,0,0,1-3.24,3.42,3.65,3.65,0,0,1-3.6-3.42,3.21,3.21,0,0,1,3.24-3.42A3.65,3.65,0,0,1,177.28,292.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.79,292.75a3.22,3.22,0,0,1-3.25,3.42,3.63,3.63,0,0,1-3.59-3.42,3.21,3.21,0,0,1,3.24-3.42A3.65,3.65,0,0,1,187.79,292.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.29,292.75a3.21,3.21,0,0,1-3.24,3.42,3.65,3.65,0,0,1-3.6-3.42,3.22,3.22,0,0,1,3.25-3.42A3.63,3.63,0,0,1,198.29,292.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.8,292.75a3.21,3.21,0,0,1-3.24,3.42,3.65,3.65,0,0,1-3.6-3.42,3.22,3.22,0,0,1,3.24-3.42A3.65,3.65,0,0,1,208.8,292.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.31,292.75a3.22,3.22,0,0,1-3.25,3.42,3.64,3.64,0,0,1-3.59-3.42,3.21,3.21,0,0,1,3.24-3.42A3.65,3.65,0,0,1,219.31,292.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333,176.62c.25.38.38.58.54.85l.45.74c.29.5.55,1,.8,1.49.5,1,1,2,1.4,3a55.2,55.2,0,0,1,2.16,6.09,63.77,63.77,0,0,1,2.38,12.54l.07.79a4.59,4.59,0,0,1,0,.48l0,.53a12.79,12.79,0,0,1-.12,2.08,17.14,17.14,0,0,1-1,3.73,25.81,25.81,0,0,1-3.46,6,42.89,42.89,0,0,1-9.31,8.81l-2.76-3.23a57.35,57.35,0,0,0,6.64-9.19,21,21,0,0,0,2-4.72,9.53,9.53,0,0,0,.33-2.14,4.69,4.69,0,0,0,0-.93l0-.21a1.3,1.3,0,0,0,0-.28l-.12-.7a79.26,79.26,0,0,0-2.72-11c-.58-1.79-1.29-3.52-2-5.21-.35-.85-.75-1.68-1.15-2.48l-.62-1.18-.31-.55-.26-.44Z",
    style: {
      fill: "#803e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.7,223.77l3.62,7.65,2.87-6.47s-2.55-5.6-6-5.08Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.91 231.8 332.79 227.08 330.19 224.95 327.32 231.42 329.91 231.8",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,408.22a10.27,10.27,0,0,0,2.22-.3.22.22,0,0,0,.15-.16.2.2,0,0,0-.09-.2c-.29-.19-2.83-1.83-3.81-1.39a.68.68,0,0,0-.39.56,1.13,1.13,0,0,0,.33,1A2.37,2.37,0,0,0,313.63,408.22Zm1.65-.59c-1.45.3-2.55.25-3-.14a.77.77,0,0,1-.21-.71c0-.17.1-.22.17-.25C312.78,406.29,314.25,407,315.28,407.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.8,407.92l.1,0a.22.22,0,0,0,.1-.18c0-.1,0-2.51-.92-3.32a1.05,1.05,0,0,0-.84-.26.69.69,0,0,0-.67.55c-.19.95,1.33,2.75,2.13,3.21Zm-1.43-3.39a.61.61,0,0,1,.44.17,4.53,4.53,0,0,1,.78,2.64c-.8-.64-1.75-2-1.63-2.57,0-.09.07-.21.32-.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.19,404.14a.21.21,0,0,0-.14-.34c-.41,0-4-.17-4.82.71l0,.06a.63.63,0,0,0-.09.62,1.11,1.11,0,0,0,.73.73c1.16.36,3.21-.95,4.33-1.76Zm-4.66.63c.45-.48,2.43-.61,3.91-.59-1.55,1.06-2.84,1.56-3.49,1.36a.72.72,0,0,1-.48-.48.27.27,0,0,1,0-.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.19,404.14l0,0a.23.23,0,0,0,0-.2c-.05-.08-1.17-2-2.49-2.4a1.45,1.45,0,0,0-1.14.14c-.48.28-.51.61-.45.82.26.93,2.81,1.75,3.91,1.74A.2.2,0,0,0,304.19,404.14Zm-3.59-2a.84.84,0,0,1,.19-.14,1,1,0,0,1,.84-.11c.87.23,1.68,1.35,2.05,1.9-1.19-.13-3-.86-3.15-1.42A.23.23,0,0,1,300.6,402.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2,147.33c-1,5-3.16,15.81.31,19.13,0,0-1.36,5-10.59,5-10.16,0-4.85-5-4.85-5,5.54-1.32,5.4-5.44,4.43-9.3Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.28,135.61a.53.53,0,0,0,.17,0,.4.4,0,0,0,.18-.54,3.94,3.94,0,0,0-2.88-2.2.41.41,0,0,0-.44.35.4.4,0,0,0,.35.44h0a3.14,3.14,0,0,1,2.26,1.77A.4.4,0,0,0,298.28,135.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.25,140a18.26,18.26,0,0,1-2.92,4,2.91,2.91,0,0,0,2.33.74Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,138.87c-.08.67-.51,1.17-.94,1.12s-.73-.64-.65-1.31.51-1.17,1-1.12S296.07,138.2,296,138.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.54,137.62,294,137S294.65,138.32,295.54,137.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.02 402.24 304.86 404.14 299.9 385.38 308.06 383.48 313.02 402.24",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.54 407.72 317.17 407.72 317.82 388.33 326.2 388.33 325.54 407.72",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5,406.75h9.41a.67.67,0,0,1,.67.58l1.07,7.44a1.34,1.34,0,0,1-1.34,1.49c-3.28-.05-4.86-.25-9-.25-2.55,0-6.27.27-9.78.27s-3.71-3.48-2.24-3.79c6.56-1.42,7.6-3.36,9.81-5.22A2.17,2.17,0,0,1,316.5,406.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14,402.89l8.55-3.93a.66.66,0,0,1,.84.24l4.09,6.32a1.35,1.35,0,0,1-.6,1.91c-3,1.32-4.52,1.81-8.28,3.54-2.31,1.06-7,3.5-10.18,5s-4.82-1.61-3.62-2.51c5.37-4,6.91-6.87,8.14-9.48A2.14,2.14,0,0,1,304.14,402.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.9 385.38 302.56 395.44 310.62 393.15 308.07 383.48 299.9 385.38",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.2 388.33 317.82 388.33 317.49 398.33 325.87 398.33 326.2 388.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,168.36c3.48.77,7.2,13.28,7.2,13.28l-9.84,10.47s-8.17-11.76-6.5-16.08C322.55,171.52,325.85,167.46,330,168.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,176.33c-1.76-1.61-2.95-1.13-3.76.15-.8,3.72,3.94,11.51,5.85,14.46C327.41,187.42,328.42,180,324.44,176.33Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91,168.61s-4,1.4,4,50.55h34c-.57-13.84-.59-22.38,6-50.8a100.28,100.28,0,0,0-14.45-1.9,107.4,107.4,0,0,0-15.44,0C293.43,167.07,285.91,168.61,285.91,168.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.6,187.47c.22,2.39.51,5.08.89,8.12,2.79-2.51,5.07-9.65,4.23-13.81A24.59,24.59,0,0,0,285.6,187.47Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.24,180a148.06,148.06,0,0,1-6.19,13.55,83.26,83.26,0,0,1-8,13l-.64.79-.32.39c-.11.13-.2.25-.37.43a12.44,12.44,0,0,1-2,1.76,16.3,16.3,0,0,1-4.18,2.08,30.53,30.53,0,0,1-8,1.42,59.36,59.36,0,0,1-15.16-1.35l.55-4.2c2.3,0,4.71,0,7-.19a56.44,56.44,0,0,0,6.86-.76,27,27,0,0,0,6.14-1.72,9.17,9.17,0,0,0,2.21-1.34,4.57,4.57,0,0,0,.69-.72s.12-.16.2-.27l.23-.33.47-.66a99.14,99.14,0,0,0,6.69-12.11c2-4.25,4-8.66,5.83-13Z",
    style: {
      fill: "#803e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91,168.61c-4.17,1-9.29,12.44-9.29,12.44l8.64,12.7s11.51-14.49,10.14-18.91C294,170.23,291,167.37,285.91,168.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.33,208.51l-7.21-3.33-.72,7.17s6,1.77,9,0Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.81 204.46 235.12 209.92 239.4 212.35 240.12 205.18 235.81 204.46",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,139.36c-1.53,8.17-2,11.67-6.68,15.38-7,5.58-16.75,1.92-17.69-6.54-.86-7.62,1.78-19.7,10.25-22A11.33,11.33,0,0,1,318.82,139.36Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,141.08c-.47,4.17-.65,15,8.51,15.34,11.21.41,14.57-9.17,13.57-13,5.84-4.75,6.68-12.92.12-19.17s-21-2.76-25,3.33C293,135.13,300.87,141.08,300.87,141.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1,126.68c-.54-4.4-.12-7.43,4-7.43s9.74,1.49,11.8,5.7,2.23,10.8-3.52,10.13S312.75,131.94,312.1,126.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,125.62c-1-5.24,3.69-20,15.08-21,5.28-.45,7.72,5.23,5,6.17,5-.06,8.2,6.55,3.54,7.54,3.68,2.36,2.77,7.2-2.48,9.58C335.71,129.71,319.83,132.88,318.48,125.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.65,131.25c-3.67,0-7.5-.54-9.88-2.13a4.89,4.89,0,0,1-2.35-3.8.26.26,0,0,1,.23-.27.24.24,0,0,1,.27.23,4.46,4.46,0,0,0,2.13,3.43c4.53,3,15,2,18.26,1,2.82-.92,4.73-2.71,5.11-4.77a4.14,4.14,0,0,0-1.67-4,.24.24,0,0,1,0-.35.25.25,0,0,1,.35,0,4.66,4.66,0,0,1,1.85,4.53c-.41,2.25-2.44,4.17-5.44,5.15A32.69,32.69,0,0,1,330.65,131.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.32,140a6.15,6.15,0,0,0-1.07,4.51c.33,2.1,2.37,2.24,3.85.9s2.77-3.76,1.68-5.5A2.62,2.62,0,0,0,298.32,140Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.89,219.16s4.86,57.49,9.91,89.89c4.07,26.17,7.29,87.34,7.29,87.34h11.42s4.06-59.34,2-85.22c-5.23-65.5,6.44-70.84-5.57-92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.27,240.89a55.8,55.8,0,0,0-10.79,16.28c1.33,12.92,2.91,27.26,4.59,39.82A110.38,110.38,0,0,0,313.27,240.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.9,218.8s-10.55,62.79-12.21,91.09c4.14,26.17,21.08,81.49,21.08,81.49l10.39-3.77s-5.75-60.32-12-76.83c14.07-47.37,24.41-59.35,21.4-91.62C312.35,219.16,290.9,218.8,290.9,218.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.38 394.14 312.42 390.33 311.62 384.73 296.59 388.8 298.38 394.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.52 396.62 329.07 396.62 329.83 391.52 314.44 391 314.52 396.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,217.16l1.53,3.05c.12.24-.16.48-.55.48H289.74c-.3,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39h34.45A.63.63,0,0,1,324.44,217.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,217.16l1.53,3.05c.12.24-.16.48-.55.48H289.74c-.3,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39h34.45A.63.63,0,0,1,324.44,217.16Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.81,221h.92c.19,0,.33-.1.32-.21l-.44-4c0-.12-.17-.21-.35-.21h-.93c-.18,0-.32.09-.31.21l.43,4C319.47,220.92,319.63,221,319.81,221Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,191.88a.52.52,0,0,1-.49-.37c-3.26-12.06-10-22-13.27-23.5a1.14,1.14,0,0,0-.85-.14.5.5,0,1,1-.41-.91,2,2,0,0,1,1.68.14c3.46,1.64,10.3,11.44,13.72,23.77,2.45,0,6.23-.33,7.15-.41,1.14-1.36,9.52-11.84,6.39-23.31a.49.49,0,0,1,.35-.61.5.5,0,0,1,.61.35c3.49,12.76-6.63,24.27-6.74,24.38a.46.46,0,0,1-.32.17C315.2,191.44,310.21,191.88,307.43,191.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,198.94c-5.45-10.21-7.68-10.93-8.65-14.21a17,17,0,0,1,3.1-5c-.66-.19-2.08-.47-3-.64.1-.45.21-.89.31-1.32a9.54,9.54,0,0,0-3,.14l0-1a13,13,0,0,0-3.87-.25q.17.71.33,1.44c-1,.19-2.52.5-3.25.71a14.4,14.4,0,0,1,3.05,5.57c-2.94,5.05-14.36,37.51,4.22,40S329.44,209.16,324,198.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,198.94c-5.45-10.21-7.68-10.93-8.65-14.21a17,17,0,0,1,3.1-5c-.66-.19-2.08-.47-3-.64.1-.45.21-.89.31-1.32a9.54,9.54,0,0,0-3,.14l0-1a13,13,0,0,0-3.87-.25q.17.71.33,1.44c-1,.19-2.52.5-3.25.71a14.4,14.4,0,0,1,3.05,5.57c-2.94,5.05-14.36,37.51,4.22,40S329.44,209.16,324,198.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.26,183.41a6.29,6.29,0,0,0-.15,1.57c0,.37,1,.62,2.11.73s5.77.29,5.62-.23.23-1.23.25-1.67-1.85-.46-3.42-.4S308.57,182.85,308.26,183.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.45,221h.92c.18,0,.32-.1.31-.21l-.43-4c0-.12-.17-.21-.36-.21H297c-.18,0-.32.09-.31.21l.43,4C297.1,220.92,297.26,221,297.45,221Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.16900d9f40a0cea22a60386c77870187.svg";
export { ForwardRef as ReactComponent };